// ---------------------------------------------------------------------------
// Section 4: Spacing — padding (T/R/B/L)
// ---------------------------------------------------------------------------

import { InspectorSection } from '@/components/inspector'
import { SpacingMiniField, extractClassValue, replaceOrAddClass } from '../fields'
import type { CogoElement } from '@/features/page-editor/store/types'

export function SpacingSection({
  element,
  updateProp: _updateProp,
  updateClass,
}: {
  element: CogoElement
  updateProp: (updates: Partial<CogoElement>) => void
  updateClass: (transform: (cls: string) => string) => void
}) {
  const cls = element.className ?? ''

  return (
    <InspectorSection title="Padding">
      {/* Padding */}
      <div>
        <div className="grid grid-cols-4 gap-1">
          <SpacingMiniField
            label="T"
            value={extractClassValue(cls, 'pt-')}
            onChange={(v) => updateClass((c) => replaceOrAddClass(c, 'pt-', v ? `pt-${v}` : ''))}
          />
          <SpacingMiniField
            label="R"
            value={extractClassValue(cls, 'pr-')}
            onChange={(v) => updateClass((c) => replaceOrAddClass(c, 'pr-', v ? `pr-${v}` : ''))}
          />
          <SpacingMiniField
            label="B"
            value={extractClassValue(cls, 'pb-')}
            onChange={(v) => updateClass((c) => replaceOrAddClass(c, 'pb-', v ? `pb-${v}` : ''))}
          />
          <SpacingMiniField
            label="L"
            value={extractClassValue(cls, 'pl-')}
            onChange={(v) => updateClass((c) => replaceOrAddClass(c, 'pl-', v ? `pl-${v}` : ''))}
          />
        </div>
      </div>
    </InspectorSection>
  )
}
